export default "__VITE_ASSET__CZn$NzGu__"